import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {ComponentForecastComponent } from './page/component-forecast.component';
import { SharedModule } from '../../shared/shared.module';
import { MaterialModule } from '../../shared/material.module';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { ComponentForecastService } from './component-forecast.service';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    MaterialModule,
    FormsModule,
    HttpModule,
  ],
  declarations: [ComponentForecastComponent],
  providers: [ComponentForecastService]
})
export class ComponentForecastModule { }
